import React, { useEffect, useContext, useMemo } from "react";
import Predicates from "constants/predicates";
import API from "constants/api";

import Form from "react-bootstrap/Form";
import { connect } from "react-redux";
import FieldEdit from "field/edit/FieldEdit";
import EditResourceDisplay from "field/edit/resource/EditResourceDisplay";
import {
  getResourceDisplayValue,
  removeObjectLink,
} from "actions/resourceActions";
import { resToJsonHandleErrors, actionError } from "helpers/actionHelpers";
import { addValue } from "actions/fieldActions";

import { useDispatch } from "react-redux";
import LocaleContext from "constants/localization";

const targetPredicate = Predicates.SPECTRUM.RELATED_OBJECT_TARGET;

const RelatedObjectModal = ({ resource }) => {
  const dispatch = useDispatch();
  const [searchActive, setSearchActive] = React.useState(false);

  const LS = useContext(LocaleContext);
  const resourceUri = resource.uri;

  let windowId = sessionStorage.getItem("WINDOW_ID");
  if (!windowId) {
    windowId = Date.now();
  }

  useEffect(() => {
    // Overrides "Attach/Liitä" in JSP search
    parent.ResourceModal.addLink = (uri) => {
      setSearchActive(false);
      getResourceDisplayValue(uri, targetPredicate, "", "", "", "").then(
        (value) => dispatch(addValue(targetPredicate, value))
      );
    };
    // Disables override on modal exit
    return () => {
      parent.ResourceModal.addLink = null;
    };
  }, [resource]);

  const displaySearchView = useMemo(() => {
    if (!searchActive) {
      return null;
    }
    const params = new URLSearchParams({
      predicateUri: targetPredicate,
      labelPredicate: "http://www.profium.com/spectrum/objectType",
      targetType: "object",
      parentUri: resourceUri,
      windowId: windowId,
    });

    const searchUri = `${API.DAM.LINK_OBJECT}?${params.toString()}`;

    return (
      <iframe style={{ width: "100%", minHeight: "37em" }} src={searchUri} />
    );
  }, [targetPredicate, resourceUri, windowId, searchActive]);

  const { validated, ref } = resource;
  const searchDisabled = resource.fields[targetPredicate].values.length > 0;
  return (
    <Form validated={validated} ref={ref}>
      {displaySearchView}
      <button
        type="button"
        onClick={() => setSearchActive(true)}
        disabled={searchDisabled}
      >
        {LS.modal.searchAndLink}
      </button>
      {Object.values(resource.fields).map((field, key) => (
        <RelatedObjectField field={field} resource={resource} key={key} />
      ))}
    </Form>
  );
};

const RelatedObjectField = ({ field, resource }) => {
  if (field.predicate === targetPredicate) {
    return <RelatedObjects field={field} resource={resource} />;
  }
  return <FieldEdit field={field} />;
};

const SearchView = ({ resource, targetPredicate, windowId, searchActive }) => {
  if (!searchActive) {
    return null;
  }
  const params = new URLSearchParams({
    predicateUri: targetPredicate,
    labelPredicate: "http://www.profium.com/spectrum/objectType",
    targetType: "object",
    parentUri: resource.uri,
    windowId: windowId,
  });

  const searchUri = `${API.DAM.LINK_OBJECT}?${params.toString()}`;
  return (
    <iframe style={{ width: "100%", minHeight: "37em" }} src={searchUri} />
  );
};

const handleClick = (uri) => (dispatch) => {
  fetch(`${API.ACCESSRIGHTS}?uri=${uri}&rightType=read`)
    .then(resToJsonHandleErrors)
    .then((json) => {
      if (json.hasAccessRights) {
        window.open(
          `${API.DAM.INDEX}?main_action=${API.DAM.DISPLAY_OBJECT}?uri=${uri}`,
          "_blank"
        );
      } else {
        dispatch(actionError({ message: "accessDenied" }));
      }
    });
  return false;
};

const RelatedObjects = connect(null, { removeObjectLink, handleClick })(
  function ({ field, resource, removeObjectLink, handleClick }) {
    const LS = useContext(LocaleContext);

    return (
      <div>
        {field.values.map((link, i) => (
          <div key={i}>
            <EditResourceDisplay value={link} />
            <a
              className="action-link"
              type="button"
              target="_blank"
              onClick={() => handleClick(link.uri)}
            >
              {LS.actions.open}
            </a>
            <button
              onClick={() =>
                removeObjectLink({
                  value: link,
                  predicate: field.predicate,
                  index: i,
                })
              }
              className="action-link"
              type="button"
            >
              {LS.actions.remove}
            </button>
          </div>
        ))}
      </div>
    );
  }
);

export default RelatedObjectModal;
